// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__C+qV6","Small":"Loader_Small__N9ITz","lds-dual-ring":"Loader_lds-dual-ring__rYh8h","Large":"Loader_Large__Q6JU6"};